import { useEffect } from "react";
import { useAuthStore } from "@/features/auth";
import { useSocket } from "@/lib/socket";
import { useNotificationsStore } from "./useNotificationsStore";

export const useNotificationsSocket = () => {
  const { user, accessToken } = useAuthStore();
  const userId = user?.userId || user?.id || user?._id || null;
  const socket = useSocket(userId, accessToken);
  const store = useNotificationsStore();

  useEffect(() => {
    if (!socket?.on || !userId) return undefined;

    const handleNotification = (payload) => {
      store.handleIncomingNotification(payload);
    };

    socket.on("server:notification", handleNotification);

    return () => {
      socket.off?.("server:notification", handleNotification);
    };
  }, [socket, store, userId]);

  return socket;
};
